const LoadingScreen = (props) => {
    return (
        <div className="loader-container">
            <div className="loader">Loading...</div>
        </div>
    )
}

export default LoadingScreen
